import { EndpointRequest } from "./endpoints/endpoints.model";

/* ENTITY */

export interface Procedure {
	id: number;
	participantId: number;
	dateOn: Date;
	type: ProcedureType;
	status: ProcedureStatus;
	notes: string | null;
	createdOn: string; // Date
	updatedOn: string; // Date
	deletedOn: string | null; // Date
}

export interface PostDischargeProcedure {
	id: number;
	participantId: number;
	dateOn: Date;
	type: PostDischargeProcedureType;
	status: ProcedureStatus;
	notes: string | null;
	createdOn: string; // Date
	updatedOn: string; // Date
	deletedOn: string | null; // Date
}

export enum ProcedureStatus {
	COMPLETED = "COMPLETED",
	SCHEDULED = "SCHEDULED",
}

export enum ProcedureType {
	GLUCOSE_TOLERANCE_TEST = "GLUCOSE_TOLERANCE_TEST",
	BIRTH = "BIRTH",
}

export enum PostDischargeProcedureType {
	DISCHARGED_FROM_HOSPITAL = "DISCHARGED_FROM_HOSPITAL",
	HOSPITAL_ADMISSION = "HOSPITAL_ADMISSION",
	ED_ADMISSION = "ED_ADMISSION",
	ED_DISCHARGE = "ED_DISCHARGE",
	CARDIAC_REHAB_START = "CARDIAC_REHAB_START",
	CARDIAC_REHAB_COMPLETION = "CARDIAC_REHAB_COMPLETION",
}

/* OTHER */

export interface ProcedureCreateForm {
	dateOn: Date | null;
	type: ProcedureType | null;
	status: ProcedureStatus | null;
	notes: string | null;
}

/* ENDPOINTS */

export interface ProcedureGetRequest extends EndpointRequest {
	config: {
		params: {
			participantId: number;
		};
	};
}

export interface ProcedureCreateRequest extends EndpointRequest {
	body: {
		participantId: number;
		dateOn: string; // Date
		type: ProcedureType;
		status: ProcedureStatus;
		notes: string | null;
	};
}

export interface PostDischargeProcedureCreateRequest extends EndpointRequest {
	body: {
		participantId: number;
		dateOn: string; // Date
		type: PostDischargeProcedureType;
		status: ProcedureStatus;
		notes: string | null;
	};
}

export interface PostDischargeProcedureUpdateRequest extends EndpointRequest {
	body: {
		participantId: number;
		dateOn: string; // Date
		type: PostDischargeProcedureType | null;
		status: ProcedureStatus | null;
		notes: string | null;
	};
}
